<div class="container margin-top-20">
  <div class="row">
    <div class="col-md-4 col-md-offset-4">
      <div class="my-account style-1 margin-top-5 margin-bottom-40">
        <ul class="tabs-nav">
          <li class="active"><a [routerLink]="'/login-register'">Log In</a></li>
          <li><a [routerLink]="'/registration'">Register</a></li>
        </ul>
        <div class="tabs-container alt">
          <div class="tab-content" id="tab1">
             <form #loginForm="ngForm" class="login" (ngSubmit)="login()">
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="loginNameControl.invalid && loginNameControl.touched"
                    [class.has-success]="loginNameControl.valid">
                    <label for="username" class="control-label">User Name / Email Address:<i class="fa fa-asterisk"></i></label>
                   <input type="text" maxlength="100" class="input-text" name="username" [(ngModel)]="model.username" id="username"
                    value="" required data-message="please enter valid user name!" #loginNameControl="ngModel" />
                    <div class="notification error" *ngIf="loginNameControl.invalid && loginNameControl.touched">
                      <p>User Name or email address filed is required</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-bottom-10">
                <div class="col-md-12">
                  <div class="form-group" [class.has-error]="loginPasswordControl.invalid && loginPasswordControl.touched"
                    [class.has-success]="loginPasswordControl.valid">
                    <label for="password" class="control-label">Password:<i class="fa fa-asterisk"></i></label>
                    <input class="input-text" maxlength="35" type="password" name="password" [(ngModel)]="model.password" id="password"
                    required #loginPasswordControl="ngModel" />
                    <div class="notification error" *ngIf="loginPasswordControl.invalid && loginPasswordControl.touched">
                      <p>Password field is required</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="form-row">
                <input type="submit" class="submit button margin-top-20" id="submit" value="Login"
                [disabled]="loginForm.invalid" />
              </p>
              <p class="lost_password margin-top-5">
                <a [routerLink]="'/forgot-password'">Forgot Password?</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
